import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle
} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";

import filterFactory from "react-bootstrap-table2-filter";

import { getBusinessCards } from "../../services/api/api-service";

const BusinessCardList = () => {

  const [list, setList] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {

      const response = await getBusinessCards();

      // Only users who have created a business card
      const cards = (response || []).filter(
        item => item.visitingCardTemplate
      );

      setList(cards);

    } catch (err) {
      console.log(err);
    }
  };

  const columns = [


    {
  dataField: "businessCardCreatedAt",
  text: "Card Created",
  sort: true,
  formatter: cell => {
    if (!cell) return "-";

    return new Date(cell).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }
},

    {
      dataField: "contactName",
      text: "Contact Name",
      sort: true
    },

    {
      dataField: "contactNumber",
      text: "Mobile",
      sort: true
    },

    {
      dataField: "email",
      text: "Email",
      sort: true
    },

    {
      dataField: "businessTypeTag",
      text: "Business Type",
      sort: true
    },

    {
      dataField: "businessName",
      text: "Business / Vehicle",
      sort: true
    },

    {
      dataField: "visitingCardTemplate",
      text: "Template",
      sort: true
    },

    {
      dataField: "address",
      text: "Address",
      sort: true
    },

    {
      dataField: "referenceTransportName",
      text: "Reference Transport",
      formatter: cell => cell || "-"
    },

    {
      dataField: "referenceMobileNumber",
      text: "Reference Mobile",
      formatter: cell => cell || "-"
    },

    {
      dataField: "vehicleChesisNumber",
      text: "Chessis Number",
      formatter: cell => cell || "-"
    },

    {
      dataField: "engineNumber",
      text: "Engine Number",
      formatter: cell => cell || "-"
    },


    {
      dataField: "state",
      text: "State",
      sort: true
    }

  ];

  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;

  return (
    <div className="page-content">
      <Container fluid>

        <Breadcrumbs
          title="Admin"
          breadcrumbItem="Business Cards"
        />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>

                <CardTitle>
                  Business Card Users
                </CardTitle>

                <ToolkitProvider
                  keyField="id"
                  data={list}
                  columns={columns}
                  search
                  exportCSV
                >
                  {props => (
                    <>
                      <Row className="mb-3">

                        <Col md="4">
                          <SearchBar {...props.searchProps} />
                        </Col>

                        <Col md="8" className="text-end">
                          <ExportCSVButton
                            {...props.csvProps}
                            className="btn btn-success"
                          >
                            Download CSV
                          </ExportCSVButton>
                        </Col>

                      </Row>

                      <BootstrapTable
                        {...props.baseProps}
                        pagination={paginationFactory({
                          sizePerPage: 10
                        })}
                        filter={filterFactory()}
                        classes="table table-bordered"
                      />
                    </>
                  )}
                </ToolkitProvider>

              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default BusinessCardList;